import * as React from "react";
import {
  List,
  DataTable,
  BooleanField,
  SearchInput,
  BooleanInput,
  EditButton,
  AutocompleteArrayInput,
  SelectArrayInput,
  ReferenceArrayField,
  SingleFieldList,
  ChipField,
  ReferenceArrayInput,
  FunctionField,
  DateField,
  DateTimeInput,
} from "react-admin";
import { RESTAURANT_TYPES } from "../enums/RestaurantTypes";
import { COUNTRIES_SHORT, getCountries } from "../enums/Countries";

const VideoFilter = () => [
  <SearchInput source="name" alwaysOn />,
  <BooleanInput label="Válidos hoy" source="availableToday" />,
  <ReferenceArrayInput
    source="restaurants"
    reference="restaurants"
    perPage={100}
    filter={{
      active: true,
      type: RESTAURANT_TYPES.REGULAR,
    }}
    label="Restaurantes"
  >
    <AutocompleteArrayInput
      filterToQuery={(searchText) => ({
        name: searchText,
        type: RESTAURANT_TYPES.REGULAR,
      })}
      label="Restaurantes"
      optionText="name"
    />
  </ReferenceArrayInput>,
  // <ReferenceInput
  //   source="product"
  //   reference="products"
  //   perPage={100}
  //   filter={{
  //     active: true,
  //   }}
  //   label="Producto"
  // >
  //   <AutocompleteArrayInput
  //     filterToQuery={(searchText) => ({ name: searchText })}
  //     label="Producto"
  //     optionText="name"
  //   />
  // </ReferenceInput>,
  <DateTimeInput source="startDate" label="Fecha de Inicio" />,
  <DateTimeInput source="endDate" label="Fecha de Fin" />,
  <SelectArrayInput label="País" source="country" choices={getCountries()} />,
  <BooleanInput label="Activo" source="active" />,
];

const VideoList = () => (
  <List
    title="Videos"
    filters={VideoFilter()}
    sort={{ field: "order", order: "ASC" }}
    exporter={false}
  >
    <DataTable rowClick="show" bulkActionButtons={false}>
      <DataTable.Col source="name" label="Nombre" />
      <DataTable.Col source="restaurants" label="Restaurantes">
        <ReferenceArrayField
          label="Restaurantes"
          reference="restaurants"
          source="restaurants"
        >
          <SingleFieldList linkType={false}>
            <ChipField source="name" size="small" />
          </SingleFieldList>
        </ReferenceArrayField>
      </DataTable.Col>
      {/* <ReferenceArrayField
        label="Productos"
        reference="products"
        source="products"
      >
        <SingleFieldList linkType={false}>
          <ChipField source="name" size="small" />
        </SingleFieldList>
      </ReferenceArrayField> */}
      <DataTable.Col source="regions" label="Región">
        <ReferenceArrayField
          source="regions"
          reference="regions"
          perPage={100}
          label="Región"
        >
          <SingleFieldList linkType={false}>
            <ChipField source="name" size="small" />
          </SingleFieldList>
        </ReferenceArrayField>
      </DataTable.Col>
      <DataTable.Col source="countries" label="Países">
        <FunctionField
          source="countries"
          render={(record) =>
            `${record.countries
              ?.map((c) => {
                return c === COUNTRIES_SHORT.AR
                  ? "Argentina"
                  : c === COUNTRIES_SHORT.CL
                    ? "Chile"
                    : "";
              })
              .join(", ")}`
          }
          label="Países"
        />
      </DataTable.Col>
      <DataTable.Col source="startDate" label="Fecha de Inicio">
        <DateField
          source="startDate"
          label="Fecha de Inicio"
          showTime={true}
          emptyText="-"
        />
      </DataTable.Col>
      <DataTable.Col source="endDate" label="Fecha de Fin">
        <DateField
          source="endDate"
          label="Fecha de Fin"
          showTime={true}
          emptyText="-"
        />
      </DataTable.Col>
      <DataTable.Col source="active" label="Activo">
        <BooleanField source="active" label="Activo" />
      </DataTable.Col>
      <DataTable.Col>
        <EditButton />
      </DataTable.Col>
    </DataTable>
  </List>
);

export default VideoList;
